import styled from 'styled-components'

export const View = styled.div``
